class Validate {
    static isPhone(str){
      const value = str.replaceAll(' ', '')
      const PHONE_LENGTH = 13
      return value.length !== PHONE_LENGTH ? false : true
    }
    static psw(str){
      const MIN_LENGTH = 5
      const MAX_LENGTH = 20
	  return str.length > MIN_LENGTH && str.length < MAX_LENGTH ? true : false
    }
    static isEmail(str){
      if(str.includes("*") || str.includes("/")) return false
      const regex =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
     return regex.test(String(str).toLowerCase())
    }
}
export default Validate